import Select from "react-select";

interface CommonSelectDropDownTagProps<T extends Record<string, any>> {
    itemMap: T[];
    label: keyof T | ((item: T) => string);
    value: keyof T | ((item: T) => any);
    placeholderText: string;
    className?: string;
    isMulti: boolean;
    name: any;
    setName: (value: any) => void;
    isRequired?: boolean;
    isDisabled?: boolean;
    dependentStates?: any;
    callBackFunction?: (value: any) => void;
    isClearable?: boolean;
    isEditorPropertyPicker?: boolean;
    disabledValue?: string | null;
}

const CommonSelectDropDownTag = <T extends Record<string, any>>({
    itemMap,
    label,
    value,
    placeholderText,
    className = "select",
    isMulti,
    name,
    setName,
    isRequired = false,
    isDisabled = false,
    dependentStates,
    callBackFunction,
    isClearable = true,
    isEditorPropertyPicker = false,
    disabledValue = null
}: CommonSelectDropDownTagProps<T>) => {
    
    const options = itemMap?.map(item => ({
        value: typeof value === "function" ? value(item) : (item[value as keyof T] as any),
        label: typeof label === "function" ? label(item) : String(item[label as keyof T]),
        isDisabled: disabledValue !== null &&
            (typeof label !== "function" && String(item[label as keyof T]) === disabledValue)
    }));
    
    const handleChange = (selectedValue: any) => {
        if (dependentStates) {
            dependentStates.forEach((setState:any)=> setState(null));
        }
        
        const selectedValues = Array.isArray(selectedValue) 
            ? selectedValue.map(subValue => subValue.value) 
            : selectedValue?.value;
        
        callBackFunction ? callBackFunction(selectedValues) : setName(selectedValues);
    };
    
    return (
        <>
        
        <Select
            name={name}
            className={className}
            isClearable={isClearable}
            isMulti={isMulti}
            options={options}
            placeholder={placeholderText}
            onChange={handleChange}
            isDisabled={!options || !options.length || isDisabled}
            value={options?.find(option => option.value === name)}
            required={isRequired}
            menuPlacement="auto"
        />
        </>
    );
};

export default CommonSelectDropDownTag;
